/** OAuth authorization `code` from the callback query string (ignores `state`, etc.). */
export function getOAuthAuthorizationCode(
  search: string = window.location.search,
): string | null {
  const code = new URLSearchParams(search).get('code')?.trim()

  return code || null
}

export function getOAuthCallbackState(
  search: string = window.location.search,
): string | null {
  const state = new URLSearchParams(search).get('state')?.trim()

  return state || null
}
